export default class Helpers {
    public getGuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            // tslint:disable-next-line
            const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    public static formatNumber(num: number, decimalAmount?: number): number {
        let rounding = 1;

        if (decimalAmount) {
            for (let i = 0; i < decimalAmount; i++) {
                rounding *= 10;
            }
        }
        else {
            rounding = 100;
        }

        return Math.round((num + Number.EPSILON) * rounding) / rounding;
    }

    public static compareNumbers(first: number, second: number, accuracy: number): boolean {
        var rounded = Math.round(Math.abs(first - second) * 100) / 100;
        return rounded <= accuracy;
    }
}

export const roundToTwo = (num: number): number => {
    return parseFloat(num.toFixed(2));
}

export const groupBy = (array: any[], groupKey: string) => {
    return array.reduce((entryMap, value) => entryMap.set(value[groupKey], [...(entryMap.get(value[groupKey]) || []), value]),
        new Map()
    );
}

export const sleep = async (ms: number) => {
    return new Promise(resolve => setTimeout(resolve, ms));
}